<div>
  <div class="uk-grid">
    <app-shipment-card-button
      *ngIf="parcelHistoryObjects.length > 1"
      class="uk-width-1-6 uk-padding-remove-right"
      [text]="'Wspólna'"
      title="Wspólna historia przesyłek"
      [cardName]="'common'"
      [activeCardName]="activeCardName"
      (buttonClicked)="activeCardChanged($event)"
    >
    </app-shipment-card-button>

    <app-shipment-card-button
      *ngFor="let object of parcelHistoryObjects"
      class="uk-width-1-6 uk-padding-remove-horizontal"
      [text]="object.waybill"
      title="Historia przesyłki {{object.waybill}}"
      [cardName]="object.waybill"
      [activeCardName]="activeCardName"
      (buttonClicked)="activeCardChanged($event)"
      [hidden]="parcelHistoryObjects.length == 1"
    >
    </app-shipment-card-button>

  </div>



  <div *ngIf="'common' === activeCardName"><!-- todo przejść na uk-table-striped -->
    <table class="uk-table uk-table-striped mt-23">
      <tr>
        <th style="width: 25%; text-align: center">
          {{'date' | translate}}
        </th>
        <th>
          {{'status' | translate}}
        </th>
      </tr>
      <tr  *ngFor="let historyRow of shipmentHistoryRows">
        <td style="text-align: center">
          <kbd>{{historyRow.when}}</kbd>
        </td>
        <td>
          {{historyRow.name}}
        </td>
      </tr>
    </table>
  </div>


  <app-parcel-history-view
    *ngFor="let object of parcelHistoryObjects"
    [hidden]="object.waybill !== activeCardName"
    [history]="object.history"
    [parcelId]="object.parcel_id"
    [isAdmin]="isAdmin"
    (onStatusChangedEvent)="handleStatusChangedEvent()"
  >
  </app-parcel-history-view>
</div>
